<template>
  <div>
    <div class="terms-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">Izjava o privatnosti</h2>
            <div>
              <p><strong>Opće informacije</strong></p>
              <p>
                Ova Izjava o privatnosti odnosi se na povjerljivost osobnih/ličnih podataka koji su
                prikupljeni prilikom dolaska na stranicu www.eurosan.ba, prilikom va&scaron;eg
                razgovora s nama, tokom rje&scaron;avanja prigovora ili problema s kojima ste se
                susreli prilikom posjeta stranici www.eurosan.ba, pri procesu kupovine, prilikom
                kreiranja osobnog profila i registracije Kupaca Internet stranice
                http://www.eurosan.ba te pri procesu registracije Korisnika primatelja obavijesti o
                proizvodima i akcijama Internet stranice www.eurosan.ba ili prilikom prijave
                Korisnika na primanje prilagođenih obavijesti o na&scaron;im novim ponudama i
                akcijama. Detaljnije o obradama i svrhama u koje obrađujemo va&scaron;e podatke
                pročitajte u ovoj Izjavi.
              </p>
              <p>
                Također, ova Izjava o privatnosti se odnosi na druge procese obrade koji su posredno
                i neposredno povezani sa va&scaron;im posjetom Internet stranice www.eurosan.ba
                odnosno s va&scaron;om kupovinom.
              </p>
              <p>
                Poduzeće Eurosan d.o.o., kao pružatelj usluga Internetske stranice
                www.eurosan.ba&nbsp; pridržava se važećih propisa sa ciljem za&scaron;tite
                privatnosti svojih Kupaca odnosno Korisnika, a posebice Opće uredbe o za&scaron;titi
                osobnih podataka EU.
              </p>
              <p>
                Ovim dokumentom opisano je kako voditelj obrade Eurosan d.o.o. (u daljnjem tekstu:
                Eurosan) obrađuje osobne podatke.
              </p>
              <p>
                Za sva pitanja koja vas zanimaju vezano uz ovaj dokument&nbsp; odnosno ako imate
                pitanja u vezi osobnih podataka možete nas kontaktirati na webshop@eurosan.ba.
              </p>
              <p>
                Upućuju se Kupci Internet stranice eurosan.ba (u daljnjem tekstu: Kupci) odnosno
                Korisnici primatelji obavijesti o proizvodima i akcijama na eurosan.ba (u daljnjem
                tekstu: Korisnici) da pročitaju sve navedeno na ovoj stranici kako bi lak&scaron;e
                razumjeli koje podatke Eurosan prikuplja i obrađuje, u koju svrhu, temeljem koje
                pravne osnove, s kime ih i za&scaron;to dijeli, koje za&scaron;titne mjere provodi,
                te koja su va&scaron;a prava vezano za pristup osobnim podacima, ispravak, brisanje
                te va&scaron;e pravo na prigovor.
              </p>
              <p>
                Klikom prilikom registracije Kupca odnosno prijavom na Internet stranici eurosan.ba
                od strane Korisnika primatelja obavijesti o proizvodima i akcijama na eurosan.ba,
                Kupac odnosno Korisnik potvrđuje da je pročitao, razumio i da se slaže sa obradom
                osobnih podataka kako ih ova Izjava utvrđuje.
              </p>
              <p><strong>Koju vrstu osobnih podataka eurosan.ba prikuplja i obrađuje?</strong></p>
              <ol>
                <li>
                  Prilikom registracije osobe kao poslovnog Kupca eurosan.ba Internet stranice,
                  Eurosan će od budućeg Kupca zatražiti pružanje određenih informacija o sebi
                  (osobnih podataka) kao &scaron;to su ime i prezime, naziv kompanije, adresa
                  (uključujući po&scaron;tanski broj), e-mail adresa, telefonski broj, država, grad,
                  korisničko ime i lozinka. Uz to, potrebno je da nam date i informaciju koji
                  sektor/djelatnost vas zanima kako bi izgled početne stranice proizvoda mogao biti
                  personaliziran za vas, s proizvodima koji su značajni za va&scaron;u djelatnost.
                  Uz navedene podatke u trenutku kada pristupite stranici www.eurosan.ba prikupit
                  ćemo i va&scaron;u IP adresu koja se, također, smatra osobnim podatkom.
                </li>
              </ol>
              <p>
                Kupac odnosno Korisnik unosom svojih osobnih podataka nakon registracije, a u
                slučaju kupnje sklapa ugovorni odnos koji je temelj za kupnju proizvoda i narudžbu
                usluga po izboru kupca na Internet stranici www.eurosan.ba. Obrada va&scaron;ih
                osobnih podataka u potonjem slučaju nužna je za izvr&scaron;avanje ugovora u kojem
                ste kao Kupac odnosno Korisnik stranka ili kako bi se poduzele radnje na zahtjev
                ispitanika prije sklapanja ugovora.
              </p>
              <p>
                Moći ćete nam dati privolu za kori&scaron;tenje kolačića koji nam pomažu za izradu
                analitičkih izvje&scaron;ća te za kori&scaron;tenje kolačića koji nam pomažu pri
                kreiranju prilagođenih sadržaja i ciljano ogla&scaron;avanje. Nakon unosa podataka
                i/ili odabira kolačića Eurosan i na&scaron;i ogla&scaron;ivački partneri koristit će
                va&scaron;e podatke za personalizirano ogla&scaron;avanje u odnosu na usluge koje
                nudimo. Eurosan u svrhu prilagođavanja (personalizacije) usluga i promocija koristi
                internetske tehnologije uobičajene i prisutne na trži&scaron;tu. Ukoliko ne želite
                da vam pružimo uslugu ciljanog ogla&scaron;avanja odnosno ukoliko ne želite da vam
                pružamo samo ogla&scaron;avanje i ponude koje su relevantne za vas ne morate
                popuniti svoj profil i ne morate dati privolu u odnosu na kolačiće koji se tiču
                izrade analitičkih izvje&scaron;ća i marketin&scaron;ke kolačiće.
              </p>
              <ol start="2">
                <li>
                  Na eurosan.ba, kao privatni kupac možete kupovati i kao gost bez registracije. U
                  ovom slučaju Eurosan će prilikom kupovine obrađivati va&scaron;e osobne podatke
                  kao &scaron;to su ime, prezime, adresa dostave (u slučaju da ste odabrali dostavu
                  na adresu dostavnom službom), podaci o kartici. Obrada va&scaron;ih osobnih
                  podataka nužna je za izvr&scaron;avanje ugovora u kojem ste kao Kupac stranka ili
                  kako bi se poduzele radnje na zahtjev ispitanika prije sklapanja ugovora. Nudimo
                  vam da adresu dostave spremite za buduće kupnje u tom slučaju aktivnom radnjom
                  ćete spremiti adresu kako bi ju na&scaron; sustav zapamtio i spremio sukladno
                  va&scaron;em odabiru. Dakle, primarnu adresu dostave možete spremiti i va&scaron;
                  odabir kasnije, ukoliko se predomislite možete promijeniti. Također, ukoliko
                  želite možete pohraniti u na&scaron;im sustavima i podatke o plaćanju kako biste
                  kasnije jednostavnije ostvarivali kupnju na www.eurosan.ba.
                </li>
                <li>
                  Prilikom registracije osobe za Korisnika primatelja obavijesti o proizvodima i
                  akcijama eurosan.ba Internet stranice &scaron;to podrazumijeva primanje obavijesti
                  newslettera, Eurosan će od budućeg Korisnika zatražiti unos e-mail adrese. Pravna
                  osnova za obradu va&scaron;ih podataka je privola. Korisnik koji se prijavljuje za
                  primanje obavijesti o proizvodima i akcijama unosom svojih podataka na Internet
                  stranici www.eurosan.ba te dvostrukom potvrdom ispravnosti mail adrese, daje
                  privolu za obradu svojih osobnih podataka. Privolu Korisnik može povući u svakom
                  trenutku obavije&scaron;ću na mail adresu:
                  <a href="mailto:info@eurosan.ba">info@eurosan.ba</a>
                </li>
              </ol>
              <p>
                Na&scaron;i Kupci newsletter odnosno druge obavijesti mogu primati i na osnovi
                legitimnog interesa. Newsletter nudi inspirativni sadržaj, primjerice aktualne
                informacije o brendovima, trendovima, ponudama, prodaji, kategorijama na&scaron;ih
                proizvoda; promotivnim cijenama proizvoda na va&scaron;em popisu želja; prilagođene
                preporuke proizvoda ako na temelju va&scaron;ih prethodnih narudžbi i va&scaron;ih
                navika pregledavanja pretpostavimo da bi vas oni mogli zanimati.
              </p>
              <ol start="4">
                <li>
                  Eurosan automatski prikuplja osobne podatke s va&scaron;eg računala, a postoje i
                  situacije u kojima prikupljamo druge vrste podataka kao &scaron;to su datum i
                  vrijeme pristupa na Internet stranicu www.eurosan.ba, informacije o hardveru,
                  softveru ili internetskom pretraživaču koji koristite kao i o operativnom sustavu
                  va&scaron;eg računala te verziji aplikacije i va&scaron;im jezičnim postavkama.
                  Možemo prikupljati informacije o klikovima i va&scaron;em pristupu Eurosan
                  stranicama koje su vam prikazane.
                </li>
              </ol>
              <p>
                Eurosan preporučuje Kupcima da brinu o svojoj ulaznoj lozinki za korisnički račun
                Internet stranice www.eurosan.ba. Preporučujemo prilikom odabira kombinacije znakova
                za lozinku svakako kombinirati velika i mala slova te brojeve, te da svakako
                upotrijebite lozinku od barem &scaron;est znakova. Lozinku preporučujemo periodično
                promijeniti (barem jednom na godi&scaron;njem nivou).
              </p>
              <p>
                U slučaju da Kupac odnosno Korisnik ne pruži tražene informacije koje su određene
                kao obvezne da bi izvr&scaron;ili za vas traženu ili očekivanu aktivnost, nažalost,
                neće vam biti dopu&scaron;teno uključivanje u istu, jer bez traženih podataka
                aktivnost neće biti tehnički provediva.
              </p>
              <ol start="5">
                <li>
                  Prilikom osobnog preuzimanja robe na adresama gdje je Eurosan omogućio osobno
                  preuzimanje robe, Eurosan će od osobe koja je pristupila preuzimanju (Kupca ili
                  Preuzimatelja koji preuzima za Kupca) zatražiti pružanje određenih informacija o
                  sebi (osobnih podataka) kao &scaron;to su ime i prezime te broj OI ili OIB ili
                  drugi identifikacijski broj sa osobnog identifikacijskog dokumenta koji osoba koja
                  preuzima robu ima kod sebe. Eurosan će također zatražiti na uvid taj osobni
                  identifikacijski dokument (npr. Osobna iskaznica, Paso&scaron;, Vozačka dozvola)
                  kako bi uvidom u njega bilo utvrđen identitet osobe koja preuzima robu.
                  Identifikacijski dokument neće biti kopiran niti na bilo koji drugi način
                  pohranjen. Ovaj uvid u osobni identifikacijski dokument nužan je iz razloga
                  &scaron;to Eurosan mora sa sigurno&scaron;ću znati kome predaje robu iz
                  skladi&scaron;ta te povezati izdanu robu, dokument o preuzimanju s transakcijom
                  kupnje robe.
                </li>
              </ol>
              <p>
                Nakon uspje&scaron;ne identifikacije osobe koja preuzima robu, ovla&scaron;tena
                osoba vratit će osobni identifikacijski dokument i pristupiti ispunjavanju Potvrde o
                preuzimanju robe, u koji će upisati ime i prezime osobe koja preuzima robu i njezin
                OI ili OIB ili drugi identifikacijski broj sa osobnog identifikacijskog dokumenta u
                koji je izvr&scaron;ila uvid.
              </p>
              <p>Za poslovne kupce:</p>
              <p>
                Kada je u pitanju osoba koja preuzima robu za pravnu osobu, nužno je da ta osoba
                posjeduje i žig te pravne osobe bez kojeg joj neće biti moguće izdati robu.
              </p>
              <p>
                Kupac se potpisuje na dokumentu izdavanja robe da je preuzeo po&scaron;iljku.
                Potvrda o preuzimanju robe se sprema u arhivu poduzeća Eurosan d.o.o. i čuva 10
                godina jer je u kategoriji računovodstvenog dokumenta. Ova Potvrda se može ispisati
                na zahtjev kupca.
              </p>
              <p>
                Poduzeće Eurosan d.o.o. koristi videonadzor, te prilikom osobnog preuzimanja
                proizvoda dolazi do snimanja Kupca. Samo ovla&scaron;tene osobe voditelja obrade
                mogu pristupiti snimkama. Eurosan kao voditelj obrade putem sustava videonadzora
                obrađuje va&scaron;e osobne podatke kao &scaron;to su snimke va&scaron;eg lika,
                način hoda, fizionomiju, i dr. Va&scaron;i osobni podaci obrađuju se u ovom slučaju
                temeljem zakona i legitimnog interesa. Kori&scaron;tenje sustava videonadzora dio je
                na&scaron;ih sigurnosnih politika. Videonadzor koristimo radi smanjenja rizika od
                razbojni&scaron;tva, provala, nasilja, krađa i sličnih događaja koji mogu uzrokovati
                &scaron;tetu u odnosu na vas kao Korisnike, ali i na poduzeće Eurosan d.o.o. kao
                voditelja obrade.
              </p>
              <ol start="6">
                <li>
                  Ukoliko komunicirate s nama, pitate nas ne&scaron;to o proizvodima ili
                  pi&scaron;ete recenzije proizvoda, bilo telefonom, po&scaron;tom, putem usluga
                  dru&scaron;tvenih mreža, obrazaca za kontakt morate znati da prikupljamo sadržaj
                  va&scaron;e komunikacije ili va&scaron;e podatke kao &scaron;to je IP adresa,
                  track ID, lokacija, nadimak ili ime koje je vezano uz registracijski obrazac
                  odnosno ˝Moj profil˝.
                </li>
                <li>
                  Redovito objavljujemo i dijelimo sadržaj, ponude i preporuke za na&scaron;e usluge
                  i proizvode na dru&scaron;tvenim mrežama. Uz svaku va&scaron;u interakciju na
                  dru&scaron;tvenim mrežama, operateri odnosno pružatelji usluga dru&scaron;tvenih
                  mreža bilježe va&scaron;e pona&scaron;anje kori&scaron;tenjem kolačića i sličnih
                  tehnologija. Pružatelji usluga odnosno operateri dru&scaron;tvenih mreža mogu
                  pregledavati opće statistike o interesima i demografskim karakteristikama (kao
                  &scaron;to su dob, spol, regija) publike stranice obožavatelja stoga dolazi do
                  obrade podataka. Ako koristite dru&scaron;tvene mreže, vrstu, opseg i svrhe obrade
                  podataka na dru&scaron;tvenim mrežama prvenstveno određuju operateri
                  dru&scaron;tvenih mreža te vas molimo da podesite na dru&scaron;tvenim mrežama
                  svoje postavke. Eurosan će obrađivati u sklopu ove obrade samo podatke ukoliko nam
                  se obratite s nekim pitanjem ili komentarom na dru&scaron;tvenoj mreži, i sl.
                </li>
                <li>
                  Kupci i Korisnici Eurosan usluga i proizvoda često koriste internetske i mobilne
                  usluge pri čemu je neizbježno generiranje i obrada tehničkih podataka kako bi vam
                  pružili sadržaj koji od nas očekujete i kako bi se isti mogao prikazati na
                  va&scaron;em uređaju. Te podatke zajednički nazivamo "podacima o uređaju i
                  pristupu". Podaci o uređaju i pristupu kreiraju se svaki put kada se koristi
                  mrežna i mobilna usluga. Nije važno tko je pružatelj usluga. Podaci o uređaju i
                  pristupu stoga nastaju, na primjer, kada koristite:
                </li>
              </ol>
              <p>- web stranice</p>
              <p>- aplikacije</p>
              <p>- stranice obožavatelja na dru&scaron;tvenim mrežama</p>
              <p>- kada se zabilježi va&scaron;a interakcija vezana uz newsletter</p>
              <p>- usluge temeljene na lokaciji</p>
              <p>Podaci o uređaju i pristupu uključuju sljedeće kategorije:</p>
              <p>
                - opće informacije o uređaju, poput podataka o vrsti uređaja, verziji operativnog
                sustava, postavkama konfiguracije (npr. jezične postavke, dopu&scaron;tenja
                sustava), informacijama o internetskoj vezi (npr. naziv mobilne mreže, brzina veze)
                i kori&scaron;tenoj aplikaciji (npr. naziv i verzija aplikacije).
              </p>
              <p>
                - podatke za identifikaciju (ID-ovi), poput ID-a sesija, ID-a kolačića, jedinstveni
                identifikacijski brojevi uređaja (npr. Google-ov ID ogla&scaron;avanja, Apple
                Ad-ID), ID-ovi računa pružatelja treće strane (ako imate dru&scaron;tvene dodatke
                ili dru&scaron;tvene prijave ) i druge uobičajene internetske tehnologije kako bismo
                mogli prepoznati va&scaron; web preglednik, uređaj ili određenu instalaciju
                aplikacije. Primjer, ako aktivirate uslugu push obavijesti dodijelit će vam se
                nasumično generirani jedinstveni push ID za identifikaciju. Kasnije ćemo poslati
                push ID zajedno s push obavijestima na push server kako bi mogao uputiti obavijest
                ispravnom primatelju, tj. va&scaron;em uređaju.
              </p>
              <p><strong>Svrhe u koje obrađujemo va&scaron;e osobne podatke</strong></p>
              <p>
                Poduzeće Eurosan d.o.o. prikuplja i obrađuje osobne podatke Kupca Internet stranice
                www.eurosan.ba u svrhu provođenja sigurne provjere autentičnosti Kupaca koji
                pristupaju Internet stranici eurosan.ba, realizacije ugovora o kupnji robe ili
                usluga, dostave robe Kupcu, komunikacije s Kupcem, eventualnih pravnih postupaka
                vezanih uz realizaciju ugovora, te dijelom primjenjujemo i automatizirane procese za
                obradu kako bismo stalno unaprjeđivali svoje procese u interesu Kupaca, kako bi
                ponuda za Kupca bila individualnija te kako bi svoju ponudu proizvoda i usluga
                &scaron;to vi&scaron;e prilagodili navikama i potrebama Kupaca.
              </p>
              <p>
                Eurosan prikuplja i obrađuje osobne podatke Korisnika primatelja obavijesti o
                proizvodima i akcijama u svrhu slanja obavijesti, eventualnih pravnih postupaka
                vezanih uz realizaciju ugovora, radi stvaranja korisničkog profila s ciljem
                individualnog primanja obavijesti, istraživanja trži&scaron;ta te pobolj&scaron;anja
                efikasnosti i kvalitete na&scaron;ih usluga.
              </p>
              <p>
                Ne prikupljamo podatke o djeci. Uvjerimo li se kako su takvi podaci preneseni nama
                bez pristanka roditelja ili skrbnika djece mlađe od 16 godina, uklonit ćemo ih bez
                odgađanja. Svi mlađi od 16 godina ne smiju koristiti www.eurosan.ba Internetsku
                stranicu. Niti jedan dio Internetske stranice eurosan.ba nije dizajniran na način da
                privuče bilo koga tko je mlađi od 16 godina.
              </p>
              <p>
                <strong
                  >Obrada osobnih podataka u procesu plaćanja kreditnim i debitnim karticama</strong
                >
              </p>
              <p>
                Transakcije za Visa i MasterCard kartice UniCredit banke na rate procesuiraju se
                preko WebPay-a (Monri Payments d.o.o.) prilikom plaćanja na Internet stranici
                www.eurosan.ba.
              </p>
              <p>
                Eurosan ni u jednom trenutku ne raspolaže, ne prikuplja niti obrađuje osobne podatke
                unesene u svrhu procesiranja i naplate kartica. U slučaju da vas zanimaju detalji
                oko va&scaron;ih osobnih podataka prikupljenih u spomenutu svrhu mole se Kupci da se
                informiraju o obradi osobnih podataka od strane Monri Payments d.o.o. na Internet
                stranici https://monri.com/privacy-notice.
              </p>
              <p>
                Eurosan upozorava Kupca da brine o podacima navedenim na kartici kako ti podaci ne
                bi bili dostupni trećim osobama te kako ne bi bili zloupotrijebljeni.
              </p>
              <p>
                <strong
                  >Obrada osobnih podataka prilikom pružanja personaliziranih i prilagođenih
                  usluga</strong
                >
              </p>
              <p>
                Razvoj i pružanje personaliziranih odnosno prilagođenih funkcionalnosti i usluga za
                vas od iznimne nam je važnosti, naravno ukoliko vi to kao na&scaron;i Kupci i
                Korisnici želite. Bez obzira na mjesto, vrijeme i opremu koja se koristi, nudimo
                vam, u određenim slučajevima kada nam date suglasnost za navedeno, individualno
                iskustvo kupnje i ponudu prilagođenu va&scaron;im individualnim interesima. Obrada
                va&scaron;ih podataka radi personalizacije na&scaron;ih usluga stoga može biti
                sastavni dio na&scaron;e usluge u Eurosan d.o.o. Primjeri: Kada pretražujete
                proizvode na www.eurosan.ba, možemo spremati va&scaron;e unose za pretraživanje. To
                znači da vam prvo možemo pokazati rezultate koji će vam vjerojatno biti osobito
                relevantni tijekom sljedećih pretraživanja na web mjestu www.eurosan.ba.Kada
                proizvod dodate u ko&scaron;aricu, možemo vam dati preporuke za odabir drugih
                proizvoda na temelju va&scaron;ih prethodnih narudžbi i povrata. Ako ste se
                pretplatili na na&scaron; besplatni newsletter, možemo vam predstaviti i prikazati
                proizvode koji odgovaraju va&scaron;im prethodnim narudžbama. Također, možemo
                uzimati u obzir va&scaron;e prethodne narudžbe prilikom predlaganja proizvoda koji
                odgovaraju va&scaron;im željama za kupovinu. Eurosan vam želi predstaviti atraktivne
                ponude i popuste prilagođene va&scaron;im preferencijama i interesima. Dakle,
                analizu va&scaron;ih interakcija na na&scaron;oj Internet stranici ili
                dru&scaron;tvenim mrežama također možemo koristiti za kreiranje i predstavljanje
                oglasa i ponuda (popusta) prilagođenih &scaron;to je vi&scaron;e moguće va&scaron;im
                željama i očekivanjima, &scaron;to može utjecati na va&scaron;e potro&scaron;ačke
                odluke.
              </p>
              <p><strong>S kojim primateljima Eurosan dijeli osobne podatke? </strong></p>
              <p>
                Eurosan neće dijeliti osobne podatke Kupca odnosno Korisnika s drugim stranama osim
                u niže navedenim slučajevima i situacijama kada to pozitivni propisi zahtijevaju.
              </p>
              <p>
                Eurosan će kada to zahtijeva realizacija ugovora za kupovinu proizvoda/usluga po
                narudžbi Kupca ili kada to zahtijeva važeći pozitivni propis BiH podijeliti osobne
                podatke Kupca s:
              </p>
              <ol>
                <li>
                  Pružateljima usluga distribucije robe s kojima ima trajni ugovor te u tu svrhu za
                  ispunjavanje narudžbi, isporuku robe, slanje zemaljske po&scaron;te i e-mail
                  po&scaron;te. Pružatelj usluga distribucije može od osobe koja je pristupila
                  preuzimanju zatražiti na uvid osobni identifikacijski dokument (npr. osobna
                  iskaznica, paso&scaron;/putovnica, vozačka dozvola) u trenutku isporuke paketa
                  prilikom osobnog preuzimanja robe, a sve u svrhu realizacije usluge isporuke
                  paketa i evidencije o tome tko je preuzeo paket. Ako osoba koja je pristupila
                  preuzimanju odbije dati ove podatke, roba mu neće biti uručena.
                </li>
                <li>
                  Pružateljima usluga ovla&scaron;tenog servisa u slučaju da Kupac podnese prigovor,
                  reklamira proizvod te je potreban pregled proizvoda ili zatraži uslugu
                  servisiranja proizvoda koji je kupio, a sve u svrhu realizacije usluge popravka,
                  servisiranja ili pregleda kupljenog proizvoda od strane servisa.
                </li>
                <li>
                  Monri Payments d.o.o. Sarajevo, ul. Džemala Bijedića 2 JIB 4202497730003 je
                  Pružatelj usluge on-line autorizacije u svrhu procesiranja transakcija koje je
                  inicirao Kupac kod Internet trgovca Eurosan prilikom kupovine robe ili usluge na
                  Internet stranici www eurosan.ba. U ovom slučaju dijele se osobni podaci: ime,
                  prezime, e-mail adresa, broj mobitela, adresa, po&scaron;tanski broj, grad,
                  država. Obrada može trajati najduže 13 mjeseci od dana provođenja pojedine
                  transakcija odnosno dana terećenja.
                </li>
                <li>
                  Pravnim subjektima koji nam pomažu u pokretanju na&scaron;eg web mjesta te nas
                  podržavaju u marketin&scaron;kim kampanjama, servisiraju na&scaron; softver,
                  pružaju podr&scaron;ku i rad na&scaron;ih ICT alata i sustava, kao i pravnih
                  subjekata koji nam pomažu u pružanju pravnih usluga koje su u tijeku, obavljanje
                  revizija itd.
                </li>
              </ol>
              <p><strong>Podaci koje o Vama prikuplja Google LLC</strong></p>
              <p>
                Eurosan koristi usluge koje pruža preduzeće Google LLC i njena povezana
                dru&scaron;tva, uključujući YouTube, Android i usluge koje se pružaju na
                web-lokacijama trećih strana, primjerice usluge ogla&scaron;avanja (dalje u tekstu:
                Google).
              </p>
              <p>
                Ova se pravila ne primjenjuju na usluge koje imaju zasebna pravila o privatnosti te
                se to ne odnosi i u njih nisu uključena Eurosan pravila o privatnosti, međutim
                sukladno propisima vezanim uz za&scaron;titu osobnih podataka Eurosan je dužan
                obavijestiti svoje korisnike i o podacima koje prikuplja Google LLC pružajući svoje
                usluge drugim pravnim i fizičkim osobama.
              </p>
              <p>
                Podaci koje Google prikuplja uključuje jedinstvene identifikatore, vrstu i postavke
                preglednika, vrstu i postavke uređaja, operativni sustav, podatke o mobilnoj mreži
                koje uključuju naziv operatera i telefonski broj te broj verzije aplikacije.
              </p>
              <p>
                Nadalje, Google prikuplja podatke o interakciji aplikacija, preglednika i uređaja s
                Google uslugama, uključujući IP adresu, izvje&scaron;ća o ru&scaron;enju, aktivnost
                sustava te datum, vrijeme i URL preporuke za zahtjev ispitanika.
              </p>
              <p>
                Google prikuplja podatke kada neka Google-ova usluga na va&scaron;em uređaju
                kontaktira Google poslužitelje -primjerice kada instalirate aplikaciju iz Trgovine
                Play ili kada usluga provjerava jesu li dostupna automatska ažuriranja. Ako
                upotrebljavate Android uređaj s Google-ovim aplikacijama, va&scaron; uređaj
                povremeno kontaktira Google-ove poslužitelje radi davanja podataka o uređaju i
                povezivanja s na&scaron;im uslugama. To uključuje podatke kao &scaron;to su vrsta
                uređaja, naziv mobilnog operatera, izvje&scaron;ća o ru&scaron;enju i aplikacije
                koje ste instalirali.
              </p>
              <ol>
                <li><strong> Podaci o va&scaron;im aktivnostima</strong></li>
              </ol>
              <p>
                Podatke o va&scaron;im aktivnostima na Google uslugama Google prikuplja kako bi vam
                na temelju njih primjerice preporučili videozapis na YouTubeu koji bi vam se mogao
                svidjeti. Podaci o aktivnostima koje Google prikuplja mogu uključivati:
              </p>
              <p>- pojmove koje tražite</p>
              <p>- videozapise koje gledate</p>
              <p>- prikaze sadržaja i oglasa te interakciju s njima</p>
              <p>- podaci o glasovnoj i audio aktivnosti prilikom upotrebe audio značajki</p>
              <p>- aktivnosti kupnje</p>
              <p>- osobe s kojima komunicirate i dijelite sadržaj</p>
              <p>
                - aktivnosti na web-lokacijama i u aplikacijama treće strane koje upotrebljavaju
                na&scaron;e usluge
              </p>
              <p>
                -povijest pregledavanja u Chrome-u koju ste sinkronizirali sa svojim Google računom.
              </p>

              <ol start="2">
                <li><strong> Podaci o lokaciji </strong></li>
              </ol>
              <p>
                Podatke o va&scaron;oj lokaciji Google prikuplja kada upotrebljavate specifične
                Google usluge. Va&scaron;a se lokacija može odrediti uz različite razine preciznosti
                na temelju:
              </p>
              <p>- GPS-a</p>
              <p>- IP adresa</p>
              <p>- podataka senzora na uređaju</p>
              <p>
                - podataka o stvarima u blizini uređaja kao &scaron;to su Wi-Fi pristupne točke,
                mobilni oda&scaron;iljači i uređaji s omogućenim Bluetoothom.
              </p>
              <p>
                U nekim okolnostima Google prikuplja podatke o vama i iz javno dostupnih izvora.
              </p>
              <p>
                Na primjer, ako se va&scaron;e ime pojavi u lokalnim novinama, Google- ova tražilica
                može indeksirati taj članak i prikazati ga drugim korisnicima kada pretražuju
                va&scaron;e ime. Važno je napomenuti da podatke o vama Google može prikupljati i od
                pouzdanih partnera, uključujući marketin&scaron;ke partnere koji pružaju podatke o
                mogućim korisnicima Google poslovnih usluga i partnera za sigurnost koji nam pružaju
                podatke za za&scaron;titu od zlouporabe kao i ogla&scaron;ivača radi pružanja oglasa
                i usluga istraživanja u njihovo ime.
              </p>
              <p>
                Ukoliko Google usluge upotrebljavate za upućivanje i primanje poziva ili slanje i
                primanje poruka, Google može prikupljati podatke telefonskog zapisnika kao
                &scaron;to su va&scaron; telefonski broj, broj koji ste nazvali, broj koji je primio
                poziv, brojeve na koje su pozivi preusmjereni, vrijeme i datum poziva i poruka,
                trajanje poziva, podatke o usmjeravanju i vrste poziva.
              </p>
              <p>
                Na svojem Google računu možete pronaći podatke o aktivnosti koje su spremljene na
                va&scaron; račun i upravljati njima.
              </p>
              <p><strong>U koje svrhe Google prikuplja va&scaron;e podatke</strong></p>
              <p>
                Va&scaron;e podatke Google može upotrebljavati kako bi osigurao ispravan rad usluga,
                primjerice praćenjem zastoja ili rje&scaron;avanjem pote&scaron;koća koje prijavite.
              </p>
              <p>Nadalje, Google podatke upotrebljava u analitičke i mjerne svrhe.</p>
              <p>
                Na primjer, Google analizira podatke o va&scaron;im posjetima Google web-lokacijama
                te upotrebljava i podatke o oglasima s kojima ste stupili u interakciju.
              </p>
              <p>
                Kada posjetite web-lokacije koje upotrebljavaju Google Analytics, Google i korisnik
                Google Analyticsa Google može povezati podatke o va&scaron;oj aktivnosti na toj web
                lokaciji s aktivnostima na drugim web-lokacijama koje upotrebljavaju Google usluge
                ogla&scaron;avanja. Prikupljene podatke, kao &scaron;to je adresa elektroničke
                po&scaron;te, Google upotrebljava za izravnu interakciju s vama. Na primjer, može
                vam poslati obavijest ako otkrije sumnjivu aktivnost, primjerice poku&scaron;aj
                prijave na va&scaron; Google račun s neuobičajene lokacije Ili vas može obavijestiti
                o predstojećim promjenama ili pobolj&scaron;anjima usluga.
              </p>
              <p>
                U slučaju da vi kontaktirate Google, Google evidentira zapis o zahtjevu radi
                lak&scaron;eg rje&scaron;avanja va&scaron;e pote&scaron;koće.
              </p>
              <p>
                Google upotrebljava automatizirane sustave koji analiziraju va&scaron; sadržaj radi
                pružanja prilagođenih rezultata pretraživanja, prilagođenih oglasa ili drugih
                značajki prilagođenih va&scaron;em načinu upotrebe na&scaron;ih usluga.
              </p>
              <p>
                Va&scaron;e sadržaje Google analizira i radi otkrivanja zloupotrebe kao &scaron;to
                su neželjeni, zlonamjerni ili nezakoniti sadržaj. Za prepoznavanje uzoraka u
                podacima Google se služi i algoritmima.
              </p>
              <p>
                Na primjer, Google prevoditelj pomaže ljudima da komuniciraju na različitim jezicima
                tako &scaron;to otkriva uobičajene jezične uzorke u frazama za koje tražite
                prijevod.
              </p>
              <p>
                Za gore opisane svrhe Google može kombinirati prikupljene podatke sa svojih usluga i
                svih va&scaron;ih uređaja. Ovisno o postavkama va&scaron;eg računa, va&scaron;a
                aktivnost na drugim web-lokacijama i u drugim aplikacijama može biti povezana s
                va&scaron;im osobnim podacima radi pobolj&scaron;anja Google-ovih usluga i oglasa
                koje Google prikazuje.
              </p>
              <p>
                Ako drugi korisnici već imaju va&scaron;u adresu elektroničke po&scaron;te ili druge
                identifikacijske podatke, Google im može prikazati va&scaron;e javno vidljive
                podatke Google računa, primjerice va&scaron;e ime i fotografiju. Tako primjerice
                mogu lak&scaron;e raspoznati elektroničku poruku koju im po&scaron;aljete.
              </p>
              <p><strong>VA&Scaron;E KONTROLE PRIVATNOSTI</strong></p>
              <p>
                Imate mogućnost izbora u vezi s podacima koje Google prikuplja o vama i načinom na
                koji ih upotrebljava.
              </p>
              <p>U ovom su odjeljku opisane glavne kontrole za upravljanje privatno&scaron;ću :</p>
              <ol>
                <li>
                  Možete posjetiti provjeru postavki privatnosti putem kojih možete pregledati i
                  prilagoditi važne postavke privatnosti.
                </li>
                <li>
                  Posjetite stranicu Provjera postavki privatnosti, Upravljanje podacima te pregled
                  i ažuriranje podataka. Kada ste prijavljeni, uvijek možete pregledati i ažurirati
                  podatke tako da posjetite usluge koje upotrebljavate.
                </li>
                <li>
                  Google je uspostavio i mjesto na kojem možete pregledati podatke koje se spremaju
                  na va&scaron; Google račun i upravljati njima.
                </li>
              </ol>
              <p>Na va&scaron;em Google računu dostupne su sljedeće kontrole:</p>
              <ol>
                <li>Kontrole privatnosti</li>
                <li>Kontrole aktivnosti</li>
              </ol>
              <p>Odredite vrste aktivnosti za koje želite da se spremaju na va&scaron; račun.</p>
              <ol start="3">
                <li>Postavke oglasa</li>
              </ol>
              <p>
                Upravljajte postavkama oglasa koji vam se prikazuju na Google-u te na web-lokacijama
                i u aplikacijama koje prikazuju oglase u partnerstvu s Google-om. Možete izmijeniti
                svoje interese, odabrati hoće li se va&scaron;i osobni podaci upotrebljavati za
                prikaz relevantnih oglasa te uključiti ili isključiti određene usluge
                ogla&scaron;avanja.
              </p>
              <ol start="4">
                <li>
                  Google vam omogućava da upravljate podatke koje drugi vide o vama na Google-ovim
                  uslugama.
                </li>
                <li>
                  Dijeljene preporuke putem Google-a. Odaberite hoće li se va&scaron;e ime i
                  fotografija prikazivati pored va&scaron;ih aktivnosti kao &scaron;to su recenzije
                  i preporuke koje se pojavljuju u oglasima.
                </li>
                <li>
                  Informacije koje dijelite. Odredite s kime ćete dijeliti podatke putem svojeg
                  računa na Google-u+.
                </li>
                <li>
                  Google vam pruža i načine za pregled i ažuriranje podataka. Na stranici Moja
                  aktivnost možete pregledati i kontrolirati podatke koji nastaju va&scaron;om
                  upotrebom Google-ovih usluga, kao &scaron;to su va&scaron;a pro&scaron;la
                  pretraživanja i posjeti Google Playu. Svoju aktivnost možete pregledavati po
                  datumu i temi te je možete izbrisati djelomično ili u cijelosti.
                </li>
                <li>
                  Uslugu Google nadzorne ploče. Putem Google nadzorne ploče možete upravljati
                  podacima koji su povezani s određenim proizvodima.
                </li>
              </ol>
              <p><strong>Va&scaron;i osobni podaci</strong></p>
              <ol>
                <li>
                  Upravljajte svojim informacijama za kontakt kao &scaron;to su ime, e-adresa i
                  telefonski broj.
                </li>
              </ol>
              <p>
                Kada niste prijavljeni, možete upravljati podacima koji su povezani s va&scaron;im
                podacima.
              </p>
              <p>
                Prilagodba pretraživanja dok ste odjavljeni: odaberite hoće li se va&scaron;a
                aktivnost pretraživanja upotrebljavati za ponudu relevantnih rezultata i preporuka.
              </p>
              <p>
                Postavke YouTube-a: pauzirajte i izbri&scaron;ite povijest pretraživanja na
                YouTube-u i povijest gledanja na YouTube-u.
              </p>
              <p>
                Postavkama oglasa upravljajte na web lokacijama i u aplikacijama koje prikazuju
                oglase u partnerstvu s Google-om.
              </p>
              <ol start="2">
                <li>Izvoz, uklanjanje i brisanje podataka</li>
              </ol>
              <p>
                Po želji možete izvesti kopiju sadržaja sa svojeg Google računa da biste ga
                sigurnosno kopirali ili koristili na nekoj usluzi izvan Googlea.
              </p>
              <p>
                Zatražite uklanjanje sadržaja s određenih Google-ovih usluga na osnovi primjenjivih
                zakona.
              </p>
              <p>Da biste izbrisali svoje podatke, možete:</p>
              <p>Izbrisati sadržaj s određenih Google-ovih usluga.</p>
              <p>
                Potražiti i zatim izbrisati određene stavke s računa putem stranice Moja aktivnost.
              </p>
              <p>
                Izbrisati određene Google-ove proizvode, uključujući podatke koji su s njima
                povezani.
              </p>
              <p>Izbrisati cijeli Google račun.</p>
              <p>
                Naposljetku, tu je i Upravitelj neaktivnih računa pomoću kojeg možete nekom drugome
                omogućiti pristup dijelovima svojeg Google računa u slučaju da ga vi&scaron;e ne
                možete upotrebljavati.
              </p>
              <p>
                Postavke preglednika: na primjer, možete konfigurirati preglednik tako da naznačite
                kada Google postavi kolačić u va&scaron; preglednik. Preglednik možete konfigurirati
                i tako da blokira sve kolačiće s određene domene ili svih domena.
              </p>
              <p>
                Pritom napominjemo da se Google usluge za ispravan rad oslanjaju na kolačiće,
                primjerice kako bi zapamtile va&scaron;e postavke jezika.
              </p>
              <p>
                Postavke uređaja: va&scaron; uređaj može imati kontrole koje određuju koje podatke
                Google može prikupljati. Na primjer, na Android uređaju možete promijeniti postavke
                lokacije.
              </p>
              <p><strong>Druge web stranice</strong></p>
              <p>Eurosan nije odgovoran za sve načine i uvjete rada trećih strana.</p>
              <p>
                Eurosan prikuplja i obrađuje osobne podatke putem interakcija korisnika na
                dru&scaron;tvenim mrežama kao &scaron;to su Facebook, Google i LinkedIn.
              </p>
              <p>
                Eurosan odnosno odgovorne osobe imenovane od strane Eurosan d.o.o. imaju uvid u
                poruke i/ili objave na spomenutim dru&scaron;tvenim mrežama, međutim osobne podatke
                prikupljene putem istih, osobito one sadržane u porukama, Eurosan ne pohranjuje te
                dodatno ne obrađuje osim u svrhe navedene u ovom dokumentu.
              </p>
              <p>
                Eurosan koristi poslovni profil koristeći usluge Facebook-a, Google-a, te LinkedIna,
                a o njihovim Pravilima privatnosti odnosno izjavama o povjerljivosti kao i o načinu
                na koji oni koriste va&scaron;e osobne podatke možete pogledati na:
              </p>
              <p>FACEBOOK ONLINE: https://www.facebook.com/policy.php&nbsp;</p>
              <p>GOOGLE ONLINE: https://policies.google.com/privacy?hl=hr</p>
              <p>
                LINKEDIN ONLINE:
                <a href="https://www.linkedin.com/legal/privacy-policy"
                  >https://www.linkedin.com/legal/privacy-policy</a
                >
              </p>
              <p><strong>Pravila o postupanju s &bdquo;kolačićima&ldquo;</strong></p>
              <p>
                Kako bi održavali web stranicu i osigurali da njezine funkcionalnosti budu na
                očekivanoj razini Eurosan koristi tehnologiju poznatu kao "kolačići".
              </p>
              <p>
                Kolačić (eng. Cookie) je podatak male veličine koji web stranica pohranjuje u
                računalo ili mobilni uređaj posjetitelja. Kolačić dozvoljava web stranici da
                &bdquo;zapamti&ldquo; akcije posjetitelja iz prethodnih posjeta. Većina preglednika
                dozvoljava upotrebu kolačića, ali korisnik ih u svakom trenutku može obrisati&nbsp;
                ili u pregledniku postaviti zabranu pohrane istih. Najče&scaron;ći razlozi
                kori&scaron;tenja kolačića su: identifikacija posjetitelja, pamćenje specifičnih
                preferencija korisnika, pomoć pri unosu informacija koje su već unesene prilikom
                prethodnih posjeta, skupljanje podataka za analize te promotivne kampanje.
              </p>
              <p>Kolačići se mogu klasificirati:</p>
              <p>Po trajanju:</p>
              <p>
                Privremeni kolačići&nbsp; - pohranjuju se na računalu , te se automatski
                bri&scaron;u nakon zatvaranja web-preglednika. Omogućuju internetskoj stranici da
                dobije privremene podatke, poput komentara ili stanja ko&scaron;arice za kupnju.
              </p>
              <p>
                Trajni kolačići&nbsp; -&nbsp; ostaju u va&scaron;em web pregledniku i nakon
                zatvaranja i obično imaju rok isteka. Pohranjuju podatke kao &scaron;to su
                korisničko ime i lozinka, &scaron;to omogućuje da koristite funkcionalnost
                &bdquo;zapamti me&ldquo; prilikom prijave, kako ne biste morali upisivati korisničko
                ime i lozinku svaki puta kada posjećujete eurosan.ba. Eurosan.ba koristi trajne
                kolačiće kako bi olak&scaron;ali pristup registriranim korisnicima.
              </p>
              <p>Po pravnoj osobi od koje dolaze:</p>
              <p>
                Kolačići prve strane - oni dolaze s web stranice koju ste posjetili, a mogu biti
                privremeni ili stalni. Omogućavaju Internet stranicama da spreme podatke koji se
                koriste&nbsp; kada korisnik ponovno posjeti Internet stranicu.
              </p>
              <p>
                Kolačić treće strane - postoji nekoliko vanjskih servisa koji korisniku spremaju
                limitirane kolačiće (Facebook, Instagram, Google Analytics i AdWords).
              </p>
              <p>Po svrsi:</p>
              <p>
                Neophodni kolačići: Ključni su za upotrebu Internet stranice i bez istih stranica
                nema svoju punu funkcionalnost. Funkcionalni kolačići mogu uključivati kolačiće koji
                pružaju uslugu koju je korisnik zatražio.
              </p>
              <p>
                Kolačići za praćenje i analitiku: Prikupljaju se anonimno, ne mogu pratiti
                aktivnosti korisnika na drugim Internet stranicama i&nbsp; služe za praćenje
                pona&scaron;anja korisnika te u svrhu&nbsp; mjerenja pona&scaron;anja publike i
                sastavljanja izvje&scaron;ća za pobolj&scaron;anja Internet stranice.
              </p>
              <p>
                Marketin&scaron;ki kolačići za personalizaciju ponude te ciljanje i
                ogla&scaron;avanje. Upotrebljavaju se za prikazivanje oglasa relevantnih za
                korisnika i njegove interese. Ovi kolačići također se mogu upotrebljavati za
                mjerenje učinkovitosti kampanje s kojom je korisnik bio u kontaktu tijekom posjeta
                Internet stranice.
              </p>
              <p>
                Eurosan vam omogućava da u bilo kojem trenutku ažurirate postavke o kolačićima.
                Također, kolačiće u bilo kojem trenutku možete obrisati. U postavkama možete
                odabrati koje kolačiće želite prihvatiti.
              </p>
              <p><strong>Izmjena Izjave o privatnosti </strong></p>
              <p>
                Ovu Izjavu o privatnosti, Eurosan može izmijeniti u bilo kojem trenutku
                objavljivanjem izmijenjenog teksta Izjave o privatnosti na Eurosan Internet
                stranici. Zato Eurosan poziva Kupce i Korisnike da povremeno pregledaju ovu Izjavu o
                privatnosti na kojoj će biti označene nove izmjene, ako ih je u prethodnom periodu
                bilo. Ukoliko se Kupac ili Korisnik ne slaže s ovom Izjavom o privatnosti, upućujemo
                Kupca i Korisnika da napusti te ne pristupa i ne koristi Internetsku stranicu
                eurosan.ba&nbsp;&nbsp;&nbsp;
              </p>
              <p>
                Izmjena izjave o privatnosti stupa na snagu odmah nakon objave na Internetskoj
                stranici www.eurosan.ba.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { translations } from '@/mixins';

export default {
  name: 'SecurityAndPrivacy',
  mixins: [translations],
};
</script>
